var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9789 20.3742C39.9789 18.7354 39.8428 17.5395 39.5483 16.2994H20.3984V23.696H31.639C31.4125 25.5342 30.1887 28.3024 27.4691 30.1626L27.431 30.4102L33.4858 34.9939L33.9053 35.0348C37.7579 31.5578 39.9789 26.4421 39.9789 20.3742Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3985 39.8626C25.9054 39.8626 30.5286 38.0908 33.9054 35.0348L27.4692 30.1626C25.7469 31.3363 23.4352 32.1557 20.3985 32.1557C15.0049 32.1557 10.427 28.6789 8.79518 23.8733L8.55598 23.8931L2.26007 28.6545L2.17773 28.8782C5.53176 35.389 12.4212 39.8626 20.3985 39.8626Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79495 23.8733C8.36437 22.6331 8.11518 21.3043 8.11518 19.9313C8.11518 18.5582 8.36437 17.2295 8.7723 15.9893L8.76089 15.7252L2.38608 10.8873L2.17751 10.9843C0.795153 13.6861 0.00195312 16.7202 0.00195312 19.9313C0.00195312 23.1424 0.795153 26.1763 2.17751 28.8782L8.79495 23.8733Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3985 7.70672C24.2284 7.70672 26.8119 9.32336 28.285 10.6744L34.0413 5.18214C30.5061 1.97099 25.9054 0 20.3985 0C12.4212 0 5.53176 4.47343 2.17773 10.9843L8.77252 15.9893C10.427 11.1837 15.0048 7.70672 20.3985 7.70672Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIco);
export default __webpack_public_path__ + "static/media/google-ico.ca46adaf7b24f7eeeacf53f8cc114fa8.svg";
export { ForwardRef as ReactComponent };